import I18n from 'i18n-js'


I18n.defaultLocale = "en";
I18n.fallbacks = true;

window.I18n = I18n
